import React, { useState, useEffect } from 'react';

const Loader = (props) => {
    const [showLoader, setLoaderStatus] = useState(false);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setLoaderStatus(true);
        }, props.thresholdInMilliseconds);

        return () => clearTimeout(timeout);
    }, [showLoader]);

    return (
        showLoader && (
            <div className="loader__container">
                <div className={`loader__background + ${props?.text?.length > 0 ? ' loader__background__opaque' : ''}`}>
                    <div id="floatingCirclesG">
                        <div className="f_circleG" id="frotateG_01"></div>
                        <div className="f_circleG" id="frotateG_02"></div>
                        <div className="f_circleG" id="frotateG_03"></div>
                        <div className="f_circleG" id="frotateG_04"></div>
                        <div className="f_circleG" id="frotateG_05"></div>
                        <div className="f_circleG" id="frotateG_06"></div>
                        <div className="f_circleG" id="frotateG_07"></div>
                        <div className="f_circleG" id="frotateG_08"></div>
                    </div>
                    <h4 className="loader__text">{props.text}</h4>
                </div>
            </div>
        )
    );
};

export default Loader;
